import LoginComponent from "../components/login/login.component";


const Login = () => {

    return (
        <>
            <LoginComponent></LoginComponent>
        </>
    )

}

export default Login;